import React, { useEffect, useState } from 'react';
import { priceFormat } from 'newFunctions/sanitizeData'
import { dateFormat } from 'newFunctions/dateFormat'
import Styles from './styles.module.sass';
import { useHistory } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { decodeStorage, encodeStorage } from 'functions/storageBase64';
import { dataLayerButtons } from 'functions/dataLayerFunction';
import { removeStorage } from 'newFunctions/storageBase64';

const ModuleImportes = (props) => {
    const { data } = props;
    const {
        monthly_payment = 0,
        minimum_to_pay = 0,
        new_balance_cutting = 0,
        payment_not_generate_interest = 0,
        payday_limit = 0
    } = data || {};
    const history = useHistory();

    const [ mensualidad, setMnsualidad ] = useState(monthly_payment);
    const [ Minimo, setMinimo ] = useState(minimum_to_pay);
    const [ Saldo, setSaldo] = useState(new_balance_cutting);
    const [ PagoNoInteres, setPagoNoInteres] = useState(payment_not_generate_interest);
    const [ FechaLimite, setFechaLimite ] = useState(payday_limit);

    const handlePayment = () => {
        removeStorage('pagoExpress')
        removeStorage('cardendingPayment')
        removeStorage('noInternetPayment')

        const cardending = decodeStorage('cardending')
        encodeStorage('cardendingPayment', cardending)
        dataLayerButtons({eventName: "credito_pagar"})
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta`);
    }

     useEffect(() => {
        if(data){
            setMnsualidad(data?.monthly_payment)
            setMinimo(data?.minimum_to_pay)
            setSaldo(data?.new_balance_cutting)
            setPagoNoInteres(data?.payment_not_generate_interest)
            setFechaLimite(data?.payday_limit)
        }
    },[data])

    return(
        <div className={`${Styles?.contSectionImpots} ${Styles?.cardStyle}`}>
            <div className={Styles?.titleCard}>Importe a pagar <span className={Styles?.handleClick} onClick={handlePayment}>Ir a pagar</span></div>
            <div className={Styles?.contImports}>
                <dl>
                    <dt>Mensualidad total:</dt>
                    <dd>${ priceFormat(mensualidad) }</dd>
                </dl>
                <dl>
                    <dt>Minímo a pagar:</dt>
                    <dd>${ priceFormat(Minimo) }</dd>
                </dl>
                <dl>
                    <dt>Saldo nuevo al corte:</dt>
                    <dd>${ priceFormat(Saldo) }</dd>
                </dl>
                <dl>
                    <dt>Pago para no generar intereses:</dt>
                    <dd>${ priceFormat(PagoNoInteres) }</dd>
                </dl>
                <dl>
                    <dt>Fecha límite de pago:</dt>
                    <dd>{dateFormat(FechaLimite)}</dd>
                </dl>
            </div>
        </div>
    )
}
export default ModuleImportes;